// extracted by mini-css-extract-plugin
module.exports = {"modal":"PopupBlockedModal_modal__HZXbr","image":"PopupBlockedModal_image__W9xgz","message":"PopupBlockedModal_message__SVrX9","button":"PopupBlockedModal_button__s_xLd"};